import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5d288a63&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d288a63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d288a63')) {
      api.createRecord('5d288a63', component.options)
    } else {
      api.reload('5d288a63', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=5d288a63&scoped=true&", function () {
      api.rerender('5d288a63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/Dashboard.vue"
export default component.exports